module.exports = __webpack_public_path__ + "img/MASTER-PIC-R.a189301f.png";